import { StyleObj } from '../../@types';
import { SkinStylesMap } from '../../hooks/useSkinStyles';
import { SKIN, Skin } from '../../types/enums';

export const SKIN_SPINNER_MAP: Partial<Record<Skin, string>> = {
  [SKIN.GOLA]: '/icons/gola-spinner.gif',
};

const BET365_STYLES: StyleObj = {
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    p: 4,
  },
  progress: {
    color: 'info.main',
  },
};

const GOLA_STYLES: StyleObj = {
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  spinnerBox: {
    width: 130,
    height: 80,
    borderRadius: '6px',
    backgroundColor: '#000',
    opacity: 0.7,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  spinnerImg: {
    width: 48,
    height: 48,
  },
};

export const LOADER_CONTAINER_SKIN_STYLES: SkinStylesMap<StyleObj> = {
  [SKIN.BET365]: BET365_STYLES,
  [SKIN.GOLA]: GOLA_STYLES,
};
